<div class="container pt-1 mb-4">
  <fgb-child-list></fgb-child-list>
  <ng-container *ngIf="(children$ | async)?.data?.length > 1">
    <div class="mt-4">
      <a href="{{ 'discount.url' | translate }}" target="_blank">
        <div class="guardian-ticket-offer-banner">
          <h3 class="text-white mb-0" style="font-size: 1.5625rem">{{ 'home.page.ticket.offer.banner' | translate }}</h3>
        </div>
      </a>
    </div>
  </ng-container>
</div>
